export default "__VITE_ASSET__BXDlF6Nl__"